<template>
  <div id="footer">
    <div class="footer">
      <div v-html="obj"></div>
      <ul class="about">
        <div class="imgcode">
           <img class="qcode" src="../../../static/img/qcode.png">
        </div>
          <div class="scrent">
          <p class="logimg">SEEONCE</p>
          <p class="fontst">电话：0592-6283333、7790910 </p>
          <p class="fontst">招生：0592-7790966、7790977</p>
       <div class="bottomst" style="font-size:0.75rem">版权所有 ©2016 集美工业学校 | 闽ICP备05026930号 | 技术支持：科技信息处 |  闽公网安备35021102000353号</div>    
        </div>
      <div class="scrent1">
          <p class="logimg"></p>
          <p class="fontst">地址：厦门市集美区杏前路22号</p>
          <p class="fontst">邮箱：bgs@jmgyxx.com</p>
        </div>

   
          <div class="rightc">
           <div class="bosx1">
              <div class="circular1">
                  34
              </div>
           </div>
           <div class="bosx1">
              <div class="circular2">
                124
              </div>
           </div>
           <div class="bosx1">
              <div class="circular3">
                85
              </div>
           </div>
            <div class="bosx1">
              <div class="circular4">
                24
              </div>
           </div>  
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      tableData1: [],
      tableData2: [],
      obj: ""
    };
  },
  mounted() {
    this.getFoot();
  },
  methods: {
    async getFoot() {
   
   
    },
    getBlogroll() {
      this.axios({
        method: "post",
        url: this.url + "/api/config/getConfigData"
      }).then(res => {
        if (res.data.code == 0) {
       
        }
      
      });
    }
  }
};
</script>

<style  scoped>
#footer {
  width: calc(100% - 6rem);
  /* background-image: url(./img/home_png_botton.png); */
  background: #061F1F;
  padding: 2rem 3rem;
  color: #fff;
  padding-bottom: 3.2rem;
}
.footer {
  width: 100%;
  margin: 0 auto;
}
.fontst{
  font-size: 0.875rem;
font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
font-weight: 400;
color: #FFFFFF;

}



.qcode{
  width:5.75rem;
  height: 5.75rem;
  padding-top: 0.2rem;
}
.imgcode{
  width: 6.1rem;
  height:6.1rem;
  background: #fff;
}
.logimg{
  height: 2rem;
  text-align: left;
  font-size: 1.6rem;
}
.scrent{
  line-height: 1.5rem;
  margin-left: 1rem;
   position: relative;
    white-space:nowrap;
}

.scrent1{
  line-height: 1.5rem;
  margin-left: 1.5rem;
  text-align: left;
   white-space:nowrap;
}
.rightc{
   margin-left: 28.25rem;

  }
.circular1{
  width: 4.25rem;
  height: 4.25rem;
  border: 0.425rem solid #62FFB4;
  border-radius: 50%;
    line-height: 4.1875rem;
}
.circular2{
  width: 4.25rem;
  height: 4.25rem;
  border: 0.425rem solid #62BEFF;
   border-radius: 50%;
    border: 0.425rem solid #62BEFF;
      line-height: 4.1875rem;
}

.circular3{
  width: 4.25rem;
  height: 4.25rem;
  border: 0.425rem solid #AB62FF;
  border-radius: 50%;
    line-height: 4.1875rem;
}
.circular4{
  width: 4.25rem;
  height: 4.25rem;
  border: 0.425rem solid #62FFD2;
  border-radius: 50%;
  line-height: 4.1875rem;
}
.bottomst{
  position: absolute;
   white-space:nowrap;
   margin-top: 1rem;
   font-size: 0.75rem;
font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
font-weight: 400;
color: #FFFFFF;

}
.bosx1{
   width:5.2rem;
   height: 4.1875rem;
   overflow: hidden;
   float: right;
   margin-right: 2rem;
  
}

.institution ul {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  color: #fff;
  height: 1.875rem /* 30/16 */;
  line-height: 1.875rem /* 30/16 */;
  font-size: 1.125rem /* 18/16 */;
  margin-bottom: 1.1875rem /* 19/16 */;
}
.institution li {
  width: calc(100% / 6);
  margin-bottom: 1rem;
  font-size: 1.125rem /* 18/16 */;
  cursor: pointer;
}
.institution li:nth-child(6n + 6) {
  margin-right: 0;
}
.institution img {
  width:100%;
}
.about {
  height:100%;
  width:100%;
  display: flex;
  justify-content: center;
  color: #fff;
  font-size: 0.875rem /* 14/16 */;
}

</style>



// WEBPACK FOOTER //
// src/components/base/vfooter.vue